<template>
  <div class="login-prompt-dialog">
    <v-dialog 
    v-model="isOpen">
    <div class="login-prompt-dialog__container">
      <div class="login-prompt-dialog__content">
          <header class="login-prompt-dialog__header">
              <h3>Please <a :href="signupUrl">Sign Up</a> or <a :href="signinUrl">Sign In</a> to save favorites</h3>
             
             
          </header>
          <v-btn
              class="login-prompt-dialog__close-button"
                icon dark @click="petStore.closeLoginPrompt()">
                  <v-icon>mdi-close</v-icon>
          </v-btn>
      </div>
    </div>
    

    </v-dialog>
  </div>
</template>


<script>
import { usePetStore } from "../stores/PetStore";
export default {

  setup() {
    const petStore = usePetStore();
    
      return { petStore };
  },
  computed: {
    isOpen: function () {
      return this.petStore.loginPromptOpen;
    },
    signinUrl: function () {
      if(!this.petStore.wpdata) {
        return "#";
      }
      return this.petStore.wpdata.wp_url + '/wp-login.php?redirect_to=' + encodeURI(this.petStore.wpdata.wp_url + '/adoption-tool/?favoritedid=' +  this.petStore.loggedOutFavoriteId);
    },
    signupUrl: function () {
      if(!this.petStore.wpdata) {
        return "#";
      } 
      return this.petStore.wpdata.wp_url + '/wp-login.php?action=register&redirect_to=' + encodeURI(this.petStore.wpdata.wp_url + '/adoption-tool/?favoritedid=' + this.petStore.loggedOutFavoriteId);
    },
    loggedOutFavoriteId: function () {

      return this.petStore.loggedOutFavoriteId;
    }
  }
};
</script>

<style lang="scss">
@import "scss/global/variables.scss";
@import "scss/global/mixins.scss";
@import "scss/global/breakpoints.scss";
@import "scss/global/layout.scss";
@import "scss/global/colors.scss";
@import "scss/global/fonts.scss";

.login-prompt-dialog {
  &__container {
    width: 100%;
    max-width: 500px;
    padding: 0 5px;
    margin: auto;
  }
  &__content {

   padding: 20px;
    // min-height: 300px;
    text-align: center;
    background-color: $lightblue;
    border: 1px solid $midblue;
    border-radius: 5px;
    box-shadow: -1px 2px 11px 5px rgb(0 0 0 / 11%);
  }
  &__header {
    position: relative;
    text-align: center;
    padding: 15px;
    h3 {
      font-size: rem(22);
    }
  }
  &__close-button {
    position: absolute !important;
    width: 30px !important;
    height: 30px !important;
    right: 10px;
    top: 10px;
  }

}

</style>

